import React, { createContext, useContext } from "react";
import useRestApi from "helpers/useRestApi";
import { AuthResponseType, UserResponseType } from "types/AuthResponseType";
import SunnySpinner from "ui/SunnySpinner";

interface AuthContextType {
  currentUser?: UserResponseType;
}

const AuthContext = createContext({} as AuthContextType);

export const useAuthContext = () => useContext(AuthContext);

type AuthProviderProps = {
  children?: React.ReactNode;
};

export function AuthProvider(props: AuthProviderProps) {
  const [{ loading, data }] = useRestApi<AuthResponseType>({
    url: "/auth",
  });

  if (loading) {
    return <SunnySpinner fullPage={true} />;
  }

  return (
    <AuthContext.Provider value={{ currentUser: data?.data || undefined }}>
      {props.children}
    </AuthContext.Provider>
  );
}
